import React from "react";

const DataTable = ({ columns, data }) => {
  return (
    <div className="overflow-x-auto w-full min-w-96 relative">
      <div className="min-w-[1000px] w-full overflow-x-hidden"> {/* Minimum width to prevent squishing */}
        <table className="w-full border-collapse">
          {/* Table Head */}
          <thead className="sticky top-0 bg-gray-50 dark:bg-gray-800 z-10">
            <tr className="border-b border-gray-200 dark:border-gray-700 text-xs text-[#3A3737] dark:text-gray-300 font-medium">
              {columns.map((col, idx) => (
                <th
                  key={idx}
                  className="bg-[#F8F8F8] dark:bg-gray-800 text-left text-[#3A3737] dark:text-gray-300 font-medium py-4 px-6 border-r border-gray-200 dark:border-gray-700"
                  style={{ minWidth: col.minWidth || '150px' }} // Minimum column width
                >
                  <div className="flex items-center gap-2">
                    {col.label}
                    {col.sortable && (
                      <svg
                        className="w-3 h-3 dark:text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="font-light relative">
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 bg-white dark:bg-gray-800 text-sm text-[#3A3737] dark:text-gray-300"
              >
                {columns.map((col, colIndex) => (
                  <td
                    key={colIndex}
                    className="py-4 px-4 border-r border-gray-100 dark:border-gray-700 align-bottom"
                  >
                    {typeof col.render === "function"
                      ? col.render(row, rowIndex)
                      : row[col.accessor] ?? <span className="text-gray-400 dark:text-gray-500">-</span>}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;